































import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { VueComponent } from '../../../../../../../../../../../../shared/types/VueComponent'
import { PlaceholdersOnes } from '../../../../../../../../../../../Editor/components/Toolbar/types'
import { AvailableButtonsTypes } from '../../../../../../../../../../../MessageEditorWithMedia/components/ButtonsConstructor/types'
import MessageEditorWithMediaData from '../../../../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/types'
import MultiMessageEditorWithMediaInput from '../../../../../../../../../../../Pi/fields/NewMultiMessageEditorWithMediaInput/MultiMessageEditorWithMediaInput.vue'
import { FieldData } from '../../../../../../../../../../../Pi/types'
import { ActionTypes } from '../../../../../logic/Actions/types'
import { ActionNodeProps } from '../../../../../logic/types'

@Component({
  components: {
    MultiMessageEditorWithMediaInput,
  },
  methods: {
    snakeCase,
  },
  data() {
    return {
      ActionTypes,
    }
  }
})
export default class NotifyUsersActionMessageSettings extends Vue {
  @Prop() message!: Array<MessageEditorWithMediaData>

  @Prop() availableButtonsTypes!: AvailableButtonsTypes

  @Prop() buttonsHelpView!: VueComponent | string

  @Prop() placeholders!: PlaceholdersOnes

  @Prop() board!: string

  @Prop() customMediaTypes!: ActionNodeProps['customMediaTypes']

  setMessageHandler(arg: FieldData): FieldData {
    arg.setter = (val) => this.setMessages(val)
    return arg
  }

  @Emit()
  setMessages(messages: Array<MessageEditorWithMediaData>): Array<MessageEditorWithMediaData> {
    return messages
  }
}
